import { List } from "immutable"
import React = require("react")
import { Container } from "./library/container"
import { Teaser } from "./teaser"

export interface GridItem {
  readonly title: string
  readonly imageUrl: string
  readonly imageAlt: string
  readonly linkUrl: string
  readonly intro: string
}

export interface GridBlockProps {
  readonly kind: "grid_block"
  row_count: number
  items: List<GridItem>
}

export class GridBlock extends React.Component<GridBlockProps, {}> {
  render() {
    const p = this.props

    return (
      <section className="block block--collections collections">
        <Container>
          <ul className="row teasers">
            {p.items.map((item, index) => 
              <Teaser
                title={item.title}
                headingLevel="h2"
                intro={item.intro}
                imageUrl={item.imageUrl}
                imageAlt={item.imageAlt}
                linkUrl={item.linkUrl}
                key={'teaser-'+index}
                row_count={p.row_count}
              />
            )}
          </ul>
        </Container>
      </section>  
    )
  }
}
